import { Attributes, EnumHelper, List, Misc, Validation, ValueObject } from '@singularsystems/neo-core';
import { SystemNoteType } from '../../Generic/NoteType';
import NoteDetail from '../../../Notes/NoteDetail';

export default class SystemNoteLookup extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public readonly noteId: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public readonly reminderDate: Date = new Date();

    public readonly noteType: SystemNoteType | null = null;

    public readonly details = new List(NoteDetail);

    // Client only properties / methods

    public get header(): string {
        return this.noteType == null ? "Note Details" : EnumHelper.getItemMetadata(SystemNoteType, this.noteType).display + " - " + this.reminderDate.toDateString();
    }

    public get showAmount(): boolean {
        return this.noteType === SystemNoteType.InvestorPaymentDateReminder || this.noteType === SystemNoteType.IssuerPaymentDateReminder;
    }

    protected static addBusinessRules(rules: Validation.Rules<SystemNoteLookup>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "System Note Lookup";
    }
}